import { Box } from '@mui/material';
import TalentSocialLinks from
  '../../../pages/TalentsPage/TalentsEdit/TalentsSocialLinkSection/TalentSocialLinks';
import TalentExperience from '../../../pages/TalentsPage/TalentsEdit/TalentExperience';
import TalentEducation from '../../../pages/TalentsPage/TalentsEdit/TalentEducation';
import TalentKeyAttributes from '../../../pages/TalentsPage/TalentsEdit/TalentKeyAttributes';
import { TalentSkills } from '../../../pages/TalentsPage/TalentsEdit/TalentSkills';
import TalentBasicDetails from '../../../pages/TalentsPage/TalentsEdit/TalentBasicDetails';
import TalentContactInfo from '../../../pages/TalentsPage/TalentsEdit/TalentContactInfo';
import MatchTalentInformation from '../MatchTalentInformation';
import MatchTalentInformationNotification from '../MatchTalentInformationNotification';
import { ContactDetail } from '../../ContactDetailsModal';
import { VIEW_MODE } from '../../../consts/enums';
import { useAuth } from '../../../hooks/useAuth';
import { PERMISSIONS } from '../../../consts/permissions';

type TalentInfoTabProps = {
  talent: FormattedTalentResponse,
  isShowNotification?: boolean,
  onApplyChanges: () => void,
  latestTalentVersion?: string | null,
  isOpenModal: boolean,
  onUpdateClick: (value:boolean) => void,
  onContactDetailsUpdate: ((contactDetails: ContactDetail) => void) | undefined,
  viewMode: ViewMode
}

export const TalentInfoTab = ({
  talent,
  isShowNotification,
  latestTalentVersion = null,
  onApplyChanges,
  isOpenModal,
  onUpdateClick,
  onContactDetailsUpdate,
  viewMode,
} : TalentInfoTabProps):JSX.Element => {
  const { hasPermissions } = useAuth();

  const canEditTalent = viewMode === VIEW_MODE.EDITABLE &&
    hasPermissions([PERMISSIONS.TALENT_EDIT, PERMISSIONS.MATCH_EDIT, PERMISSIONS.TALENT_VIEW]);

  const {
    socialLinks = [],
    employmentHistory = [],
    educationHistory = [],
    attributes = [],
    technicalSkills = [],
  } = talent || {};

  return (
    <Box>
      {/* todo: move all talent sections to common components */}

      <MatchTalentInformation
        canEditTalent={ canEditTalent }
        version={ talent.version }
        updatedAt={ talent.updatedAt || talent.createdAt }
        talentId={ talent.talentId || '' }
      />

      {(isShowNotification && canEditTalent) && (
        <MatchTalentInformationNotification
          onApplyChanges={ onApplyChanges }
          talentId={ talent.talentId }
          latestTalentVersion={ latestTalentVersion }
        />
      )}

      <TalentBasicDetails
        viewMode={ VIEW_MODE.READ_ONLY }
        firstName={ talent.firstName }
        lastName={ talent.lastName }
        city={ talent.location.city }
        state={ talent.location.state }
        country={ talent.location.country }
      />

      <TalentContactInfo
        talentId={ talent.talentId }
        emails={ talent.emails }
        phones={ talent.phoneNumbers }
        isShowUpdateContactInfo={ hasPermissions([PERMISSIONS.TALENT_CONTACT_DETAILS_EDIT]) }
        isOpenModal={ isOpenModal }
        onUpdateClick={ onUpdateClick }
        handleEmailPhoneChanged={ onContactDetailsUpdate }
      />

      <TalentSocialLinks
        viewMode={ VIEW_MODE.READ_ONLY }
        socialLinks={ socialLinks }
      />

      <TalentExperience
        viewMode={ VIEW_MODE.READ_ONLY }
        employmentHistory={ employmentHistory }
      />

      <TalentEducation
        viewMode={ VIEW_MODE.READ_ONLY }
        educationHistory={ educationHistory }
      />

      <TalentKeyAttributes
        viewMode={ VIEW_MODE.READ_ONLY }
        attributes={ attributes }
      />

      <TalentSkills
        viewMode={ VIEW_MODE.READ_ONLY }
        skills={ technicalSkills }
      />
    </Box>
  );
};

TalentInfoTab.defaultProps = {
  isShowNotification: false,
  latestTalentVersion: null,
};
